import { render, staticRenderFns } from "./WelcomeForum.vue?vue&type=template&id=57ff9582&"
import script from "./WelcomeForum.vue?vue&type=script&lang=ts&"
export * from "./WelcomeForum.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports